import React, { forwardRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { useDispatch } from 'react-redux';
import { deletePosbank } from 'http/components/SettingService';
import { setPosBanks } from '../../../../../Redux/slices/globalSlice';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DeletePos({ id, title }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [semi, setSemi] = useState(false);
  const setShowDialog = () => {
    setShow(true);
  }
  const handleClose= () => {
    setShow(false);
  }
  const onEnter = () => {
    setSemi(false);
  }

  const onFinish = async () => {
    dispatch(HandleLoading(true));
    const response = await deletePosbank(id);
    if(response.status) {
      await dispatch(setPosBanks(response.data.bank));
    }
    dispatch(HandleLoading(false));
    setShow(false);
  }

  return (
    <>
        <div className='delete' onClick={setShowDialog}>
          <icons.Trash3 size={16}/>
        </div>
        {
          show &&
          <Dialog
            open={show}
            TransitionComponent={Transition}
            keepMounted
            fullWidth={true}
            maxWidth={'xs'}
            onClose={handleClose}
            TransitionProps={{onEnter: onEnter}}
            aria-describedby="alert-dialog-slide-type-delete"
          >
            <DialogTitle className='delete-mode'>
              {'حذف دستگاه کارت‌خوان'}
              <div className='close-btn' onClick={handleClose}>
                <icons.X/>
              </div>
            </DialogTitle>
            <DialogContent>
              {
                (show && !semi) ?
                <DialogContentText id="alert-dialog-slide-appointment-edit">
                  <div className='delete-body'>
                    <div className='content'>
                      <p>
                        {'از حذف دستگاه کارت‌خوان با مشخصات زیر اطمینان دارید ؟'}
                      </p>
                      <div className='details'>
                        <p>
                          {"عنوان :"}
                          {" "}
                          <strong>{title}</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </DialogContentText> : <p className='mb-1'>
                  {"آیا از حذف مطمئن هستید ؟"}
                </p>
              }
            </DialogContent>
            <DialogActions>
              {
                semi
                ? <div className='w-100 flex-row-center-center'>
                  <CButton
                    text={'خیر'}
                    icon={<icons.XLg/>}
                    onClick={handleClose}
                    action=''
                    className={'ms-2'}
                  />
                  <CButton
                    text={'بله'}
                    icon={<icons.Trash3/>}
                    onClick={onFinish}
                    action='delete'
                  />
                </div>
                : <CButton
                  text={'حذف کارت‌خوان'}
                  icon={<icons.Trash3/>}
                  onClick={() => setSemi(true)}
                  action='delete'
                />
              }
            </DialogActions>
          </Dialog>
        }
      </>
  );
}
